import { getCurrentUrl } from './getCurrentUrl';
import { isSSR } from './isSSR';

export const getClientQueryParam = (queryParam: string): string | null =>
  isSSR() ? null : getCurrentUrl().searchParams.get(queryParam);
